import styled from 'styled-components';
import { ICON_SIZE } from '../../constants';
import { withOmitProps } from '../../helpers/elements';
import { size } from '../../style/size';
const IconWrapper = styled.span.withConfig(withOmitProps(['flex', 'pointer', 'disabled', 'inactive']))`
  display: ${({
  flex = true
}) => flex ? 'inline-flex' : 'inline-block'};
  justify-content: center;
  align-items: center;
  position: relative;
  ${({
  pointer,
  disabled,
  inactive
}) => pointer && (!disabled || !inactive) && `cursor: pointer;`}
  ${size(ICON_SIZE)}
`;
export default IconWrapper;